module.exports = __webpack_public_path__ + "media/sub6-4-2.69e618a9.mp4";